import getLocalString from "constants/Localization";
import { useDeleteDailyFormInspectionMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useDeleteDailyFormInspection() {
  const [mutation, { loading, data, error }] = useDeleteDailyFormInspectionMutation({
    refetchQueries: ["getDailyFormInspections", "customGetDailyFormInspections"],
  });

  const [deleteDailyFormInspection, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "deleteDailyFormInspection",
    },
    {
      successMessage: getLocalString("fleet.delete-inspection-success"),
      failureMessage: getLocalString("fleet.delete-inspection-failure"),
    }
  );

  return [deleteDailyFormInspection, context] as const;
}
